import type { ReactNode } from "react";

import { Box } from "@mui/material";

import { BodyText, BodyTextSmall } from "~/components/Typographies";

interface SettingRowProps {
	control?: ReactNode;
	description?: ReactNode;
	label: string;
}

const SettingRow = ({ control, description, label }: SettingRowProps) => (
	<Box
		sx={{
			alignItems: "center",
			borderBottom: 1,
			borderColor: "divider",
			display: "grid",
			gap: { md: 4, xs: 1 },
			gridTemplateColumns: { md: "minmax(0, 5fr) minmax(0, 7fr)", xs: "1fr" },
			py: 2,
			"&:last-of-type": { borderBottom: 0 }
		}}
	>
		<Box sx={{ minWidth: 0 }}>
			<BodyText sx={{ fontWeight: 500 }}>{label}</BodyText>
			{description && <BodyTextSmall color="text.secondary">{description}</BodyTextSmall>}
		</Box>
		<Box sx={{ alignItems: "center", display: "flex", flexWrap: "wrap", gap: 2, minWidth: 0 }}>{control}</Box>
	</Box>
);

export default SettingRow;
